module.exports = "/fonts/NeoSansStd-Light.svg?60562a43150bd2783be76abd585a5b55";